
<div class="main-black border-radius-bottom white-box">
	<div class="row m-0 px-4 py-5">
		<div class="col-6">
			<div class="row m-0 mb-5">
				<h3 class="font-weight-bold" *ngIf="siteInfo.name">
					{{siteInfo.name}}
					<app-help-tooltip *ngIf="tooltips.site_info" [field]="tooltips.site_info" ></app-help-tooltip>
				</h3>
				<div class="ml-auto my-auto">
					<button
						*ngIf="showRequestPasswordButton()"
						class="btn main-blue-bg text-white px-2 rounded-lg mr-2"
						(click)="requestRevealPassword()">
						<i class="fa fa-key mr-1"></i>
						{{'password_reveal.request_password_button' | translate}}
					</button>
					<button
						*ngIf="mailerSubscriptionService.hasQualifyingDevices(siteInfo)"
						class="btn main-blue-bg text-white px-2 rounded-lg mr-2"
						(click)="siteMailerSubscriptions.open()">
						{{'site_mailer_subscriptions.button' | translate}}
					</button>
					<a
						class="btn main-blue-bg text-white px-2 rounded-lg mr-2"
						[routerLink]="['download-status']">
						{{'site.site_download_status' | translate}}
					</a>
					<a *ngIf="usersService.hasAccessFunction('site_management') && currentUser.isSCT"
						class="btn main-green-bg text-white px-2 rounded-lg"
						[routerLink]="['/sites', siteInfo.customer_id, 'edit', siteInfo.id]">
						{{'site.edit_site' | translate}}
					</a>
				</div>
				<div class="w-100" *ngIf="currentUser.isSCT && siteInfo.original_enterprise && siteInfo.is_auto_generated">
					<p class="badge text-white bg-main-black-color">
						{{'site.this_site_is_generated' | translate}}
						<span *ngIf="!usersService.hasAccessFunction('enterprise_management')">
							{{siteInfo.original_enterprise_name}}
						</span>
						<a *ngIf="usersService.hasAccessFunction('enterprise_management')" routerLink="/enterprise/edit/{{siteInfo.original_enterprise}}"> {{siteInfo.original_enterprise_name}} </a>
					</p>

				</div>
			</div>

			<!-- <div class="mb-4" *ngIf="0 && currentUser['is_admin']">
				<div *ngFor="let enterprise of enterprises">
					<i><b>{{enterprise.name}}</b></i>
				</div>
			</div> -->
			<span *ngIf="usersService.hasAccessFunction('site_management')">
				<label><input type="checkbox" [(ngModel)]="showOnlyConnected" class="mr-2" (ngModelChange)="showOnlyConnectedIPs(showOnlyConnected)">{{'site.only_connected' | translate}}</label>
				<div class="row m-0 mb-3 px-3 py-2 rounded light-grey-border">
					<span class="light-grey">{{'site.unique_ip_addresses' | translate}}</span>
					<b class="ml-auto">{{uniqueIPaddresses.length > 0 ? uniqueIPaddresses.join(', ') : 'No IP'}}</b>
				</div>
			</span>

			<ng-container *ngIf="contactInfo.length">
				<div class="row mb-4">
					<div class="col-1"><i class="fa fa-envelope-o fa-2x main-blue"></i></div>
					<div class="col-11">
						<h5 class="font-weight-bold">{{'g.contact_info' | translate}}</h5>
						<div *ngFor="let field of contactInfo">
							{{field}}
						</div>
					</div>
				</div>
			</ng-container>
			<div class="row mb-4">
				<div class="col-1"><i class="fa fa-clock-o fa-2x main-blue"></i></div>
				<div class="col-11">
					<h5 class="font-weight-bold" [tooltip]="'tooltip.time_source_device' | translate">{{'devices.zone_id' | translate}}</h5>
					<div>
						{{liveSiteTime | date:'MM/dd/yyyy hh:mm:ss a'}} - {{zoneName}}
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-1"><i class="fa fa-calendar-check-o fa-2x main-blue"></i></div>
				<div class="col-11">
					<h5 class="font-weight-bold" [tooltip]="'tooltip.time_source_utc' | translate">{{'site_edit.installation_date' | translate}}</h5>
					<div>
						{{siteInfo['installation_date'] | date:'MM/dd/yyyy': 'UTC'}}
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-1"><i class="fa fa-map-marker fa-2x main-blue"></i></div>
				<div class="col-11">
					<h5 class="font-weight-bold">{{'site_edit.address' | translate}}</h5>
					<div>
						{{siteInfo['address']}}
					</div>
					<div *ngIf="siteInfo['address_line2']">
						{{siteInfo['address_line2']}}
					</div>
				</div>
			</div>
			<div class="row mb-4" *ngIf="siteInfo.brm_devices_count > 0 && usersService.hasAccessPermission({ permission: permissions }, 'basic_setup')">
				<div class="col-1"><i class="fa fa-link fa-2x main-blue"></i></div>
				<div class="col-11">
					<h5 class="font-weight-bold">{{'site.public_brm_page_info' | translate}}</h5>
					<div>
						<a href="/charglink-brm/public/{{siteInfo.brm_public_token}}" target="_blank" rel="noopener noreferrer" *ngIf="brmValidToken">
							<span name="brm_public_token" class="margin-right-sm">{{ currentSiteUrl }}/charglink-brm/public/{{siteInfo.brm_public_token}}</span>
						</a>
						<span name="brm_public_token" class="margin-right-sm" *ngIf="!brmValidToken">{{ currentSiteUrl }}/charglink-brm/public/{{siteInfo.brm_public_token}}</span>
					</div>
					<button type="button" class="btn btn-primary sm mt-2" (click)="regenerateBrmToken(true)" *ngIf="usersService.hasAccessFunction('super_admin', 'write')">{{"site_edit.regenerate_token" | translate}}</button>
				</div>
			</div>
			<div class="row mb-4" *ngIf="siteInfo.electrician_phone_num || siteInfo.electrician_contact_name || siteInfo.electrician_email">
				<div class="col-1"><img src="/sctportal/images/electrician.png" width="45"></div>
				<div class="col-11">
					<h5 class="font-weight-bold mb-2">
						{{'site.electrician_contact_info' | translate}}
					</h5>
					<div *ngIf="siteInfo.electrician_contact_name" class="mb-2">
						<h6 class="font-weight-bold">
							{{'g.contact_name' | translate}}
						</h6>
						<span>
							{{siteInfo.electrician_contact_name}}
						</span>
					</div>
					<div *ngIf="siteInfo.electrician_phone_num" class="mb-2">
						<h6 class="font-weight-bold">
							{{'g.phone_num' | translate}}
						</h6>
						<span>
							{{siteInfo.electrician_phone_num}}
						</span>
					</div>
					<div *ngIf="siteInfo.electrician_email">
						<h6 class="font-weight-bold">
							{{'g.email' | translate}}
						</h6>
						<span>
							{{siteInfo.electrician_email}}
						</span>
					</div>
				</div>
			</div>
			<div class="row mb-4" *ngIf="siteInfo.sales_person_name || siteInfo.sales_person_phone_num || siteInfo.sales_person_email">
				<div class="col-1"><img src="/sctportal/images/salesperson.png" width="45"></div>
				<div class="col-11">
					<h5 class="font-weight-bold mb-2">
						{{'site.sales_person_info' | translate}}
					</h5>
					<div *ngIf="siteInfo.sales_person_name" class="mb-2">
						<h6 class="font-weight-bold">
							{{'g.contact_name' | translate}}
						</h6>
						<span>
							{{siteInfo.sales_person_name}}
						</span>
					</div>
					<div *ngIf="siteInfo.sales_person_phone_num" class="mb-2">
						<h6 class="font-weight-bold">
							{{'g.phone_num' | translate}}
						</h6>
						<span>
							{{siteInfo.sales_person_phone_num}}
						</span>
					</div>
					<div *ngIf="siteInfo.sales_person_email">
						<h6 class="font-weight-bold">
							{{'g.email' | translate}}
						</h6>
						<span>
							{{siteInfo.sales_person_email}}
						</span>
					</div>
				</div>
			</div>
			<div *ngIf="infoBoxSiteAnalytics?.deviceCount">
				<select class="custom-select custom-select-lg mb-3" [(ngModel)]="selectedDataOption" (ngModelChange)="setInfoBoxSiteAnalyticsData()">
					<option selected value="since_installation">{{'durations.since_installation' | translate }}</option>
					<option value="last_quarter">{{'durations.last_quarter' | translate }}</option>
				</select>
			</div>
		</div>
		<div class="col-6">
			<app-mapbox-search
				*ngIf="siteInfo.id && sideMenuService.showMap"
				class="border-radius main-blue-border"
				dotsType="mix"
				[latitude]="siteInfo.latitude || sitesService.defaultMapLocation.latitude"
				[longitude]="siteInfo.longitude || sitesService.defaultMapLocation.longitude"
				zoom="2.8"
				[dots]="dots"
			></app-mapbox-search>
		</div>
	</div>
	<div class="row m-0 px-4 py-5">
		<div class="col-12">
			<app-info-box *ngIf="infoBoxSiteAnalytics"
				[ioTAhDevices]="infoBoxSiteAnalytics?.ioTAh_devices"
				[chargLinkDevices]="infoBoxSiteAnalytics?.chargLink_devices"
				[battLinkDevices]="infoBoxSiteAnalytics?.battLink_devices"
				[iotemeterDevices]="infoBoxSiteAnalytics?.iotemeter_devices"
			></app-info-box>
		</div>
	</div>
</div>

<!-- Installed Devices ( IoTAh ) -->
<div *ngIf="IoTAhDevices.length > 0 && installedIotahDeviceTableConfig.column.length > 0" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'site.site_devices' | translate}}
			<app-help-tooltip *ngIf="tooltips.site_devices" [field]="tooltips.site_devices"></app-help-tooltip>
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedIotahDeviceTableConfig.column"
		[data]="installedIotahDeviceTableConfig.data"
		[config]="installedIotahDeviceTableConfig.config"
	>
	</sct-custom-table>
</div>

<!-- Installed Devices ( ChargLink ) -->
<div *ngIf="chargeLinkDevices.length > 0 && this.installedChargerDeviceTableConfig.column.length > 0" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'chargLinkDevice.site.site_devices' | translate}}
			<app-help-tooltip *ngIf="tooltips.chargLink_site_devices" [field]="tooltips.chargLink_site_devices"></app-help-tooltip>
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedChargerDeviceTableConfig.column"
		[data]="installedChargerDeviceTableConfig.data"
		[config]="installedChargerDeviceTableConfig.config"
	>
	</sct-custom-table>
</div>

<!-- Installed Devices (BattLink) -->
<div *ngIf="allBattlinkDevices.length > 0" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{ "battlinkDevice.site.site_devices" | translate }}
			<app-help-tooltip *ngIf="tooltips.battlink_site_devices" [field]="tooltips.battlink_site_devices"></app-help-tooltip>
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedBattlinkDevicesReportsConfig.column"
		[data]="installedBattlinkDevicesReportsConfig.data"
		[config]="installedBattlinkDevicesReportsConfig.config"
	>
	</sct-custom-table>
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="meteredDevices.length"> 
	<div class="col-sm-6 col-md-6">
		<h4>
			{{"iotemeter.site.site_devices" | translate }}
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedIotemeterDeviceTableConfig.column"
		[data]="installedIotemeterDeviceTableConfig.data"
		[config]="installedIotemeterDeviceTableConfig.config"
	>
	</sct-custom-table>
</div> 

<!-- Truck Inventory Report -->
<div *ngIf="IoTAhDevices.length > 0 && truckInventoryReport.column" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'site.ioTAh_devices.truck_inventory_report' | translate}}
			<app-help-tooltip *ngIf="tooltips.truck_inventory_report" [field]="tooltips.truck_inventory_report"></app-help-tooltip>
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="truckInventoryReport.column"
		[data]="truckInventoryReport.data"
		[config]="truckInventoryReport.config"
	>
	</sct-custom-table>
</div>

<!-- Charger Inventory Report -->
<div *ngIf="chargersDevices.length > 0 && this.chargerInventoryReportTableConfig.column.length > 0" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'chargLinkDevice.site.charger_inventory_report' | translate}}
			<app-help-tooltip *ngIf="tooltips.charger_inventory_report" [field]="tooltips.charger_inventory_report"></app-help-tooltip>
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="chargerInventoryReportTableConfig.column"
		[data]="chargerInventoryReportTableConfig.data"
		[config]="chargerInventoryReportTableConfig.config"
	>
	</sct-custom-table>
</div>

<!-- BattLink Inventory Report -->
<div *ngIf="allBattlinkDevices.length" class="white-box main-black mt-4 p-4 border-radius"> 
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'battlinkDevice.site.battery_inventory_report' | translate}}
			<app-help-tooltip *ngIf="tooltips.battlink_inventory_report" [field]="tooltips.battlink_inventory_report"></app-help-tooltip>
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="batteryInventoryReport.column"
		[data]="batteryInventoryReport.data"
		[config]="batteryInventoryReport.config"
	>
	</sct-custom-table>
</div>

<!-- Summary Truck Usage Report ( IoTAh devices ) -->
<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="IoTAhDevices.length">
	<div class="row">
		<div class="col">
			<h4>
				{{'site.summary_truck_usage_report_title' | translate}}
				<app-help-tooltip *ngIf="tooltips.summary_truck_usage_report" [field]="tooltips.summary_truck_usage_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="d-flex justify-content-start col-6 align-items-center">
			<label class="mr-2">{{'g.period_type' | translate}}</label>
			<ng-select
				class="select full-width me-2"
				[items]="timePeriodFilters"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="changeSummaryReportDurationFilter($event.value)"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="selectedSummaryTruckUsageFilter"
			></ng-select>

			<label class="ml-2">{{'devices.truck_type' | translate}}</label>
			<ng-select class="select full-width"
				[searchable]="false"
				[clearable]="false"
				[items]="truckTypeList"
				bindLabel="label"
				bindValue="value"
				[(ngModel)]="selectedSummaryTruckTypeFilter"
				(change)="changeSummaryTruckReportTypeFilter($event.value)"
			>
			</ng-select>
		</div>
	</div>
	<div>
		<sct-custom-table
			[data]="summaryTruckUsageReport.data"
			[columnsConfig]="summaryTruckUsageReport.column"
			[config]="summaryTruckUsageReport.config"
			>
		</sct-custom-table>
	</div>
</div>

<!-- Summary Charger Usage Report ( ChargLink devices) -->
<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="charglinkSelectedQuarterData">
	<div class="row">
		<div class="col">
			<h4>
				{{'site.chargLinkeQuarterly_site_report_title' | translate}}
				<app-help-tooltip *ngIf="tooltips.summary_charger_usage_report" [field]="tooltips.summary_charger_usage_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="d-flex justify-content-start col-8 align-items-center">
			<!-- select year -->
			<div class="col-3">
				<label class="mr-2">{{'g.select_year' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="chargLinkYearsOption"
					bindLabel="label"
					placeholder="{{'g.select_year' | translate}}"
					name="year"
					[(ngModel)]="chargLinkSelectedYear"
					(ngModelChange)="chargerUsageReportUpdateSelectedYear()"
					[clearable]="false"
				></ng-select>
			</div>

			<!-- select period type -->
			<div class="col-3" *ngIf="chargLinkSelectedYear !== 'All Years'">
				<label class="mr-2">{{'site.select_period_type' | translate}}</label>
				<ng-select
					[items]="periodTypesItems"
					bindLabel="label"
					bindValue="id"
					placeholder="{{'site.select_period_type' | translate}}"
					name="period_type"
					[(ngModel)]="chargeLinkSelectedPeriodType"
					(ngModelChange)="chargerUsageReportUpdateSelectedPeriodType()"
					[clearable]="false"
				></ng-select>
			</div>

			<!-- select quarter -->
			<div *ngIf="chargeLinkSelectedPeriodType == periodTypes.quarter && chargLinkSelectedYear !== 'All Years'" class="col-3">
				<label class="mx-2">{{'g.select_quarter' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="chargLinkQuartersOption"
					bindLabel="label"
					placeholder="{{'g.select_quarter' | translate}}"
					name="quarter"
					[(ngModel)]="chargLinkSelectedQuarter"
					(ngModelChange)="loadQuarterData(deviceFactory.types.charglink)"
					[clearable]="false"
				></ng-select>
			</div>

			<!-- select month -->
			<div *ngIf="chargeLinkSelectedPeriodType == periodTypes.month && chargLinkSelectedYear !== 'All Years'" class="col-3">
				<label class="mx-2">{{'g.select_month' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="chargLinkMonthsOption"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'g.select_month' | translate}}"
					name="year"
					[(ngModel)]="chargLinkSelectedMonth"
					(ngModelChange)="loadQuarterData(deviceFactory.types.charglink)"
					[clearable]="false"
				></ng-select>
			</div>

		</div>
	</div>
	<div>
		<sct-custom-table
			[data]="chargLinkQuarterlyTableConfig.data"
			[columnsConfig]="chargLinkQuarterlyTableConfig.column"
			[config]="chargLinkQuarterlyTableConfig.config"
		>
		</sct-custom-table>
	</div>
</div>

<!--Summary usage report (BattLink)-->
<div *ngIf="allBattlinkDevices.length" class="white-box main-black mt-4 p-4 border-radius"> 
	<div class="col-sm-6 col-md-6">
		<h4 class="mb-4">
			{{'battlinkDevice.site.summary_usage_report' | translate}}
			<app-help-tooltip *ngIf="tooltips.summary_battlink_usage_report" [field]="tooltips.summary_battlink_usage_report"></app-help-tooltip>
		</h4>
	</div>

	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="d-flex justify-content-start col-8 align-items-center">
			<div class="col-3">
				<div>
					<label for="battery_period">{{'g.period_type' | translate}}</label>
				</div>
				<ng-select
					class="mr-auto w-100"
					[searchable]="false"
					[items]="timePeriodFilters"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'perf_analytic.period' | translate}}"
					name="battery_period"
					[(ngModel)]="selectedBatterySummaryPeriodFilter"
					(ngModelChange)="prepareBatterySummaryReport()"
					[clearable]="false"
				>
				</ng-select>
			</div>
			<div class="col-3">
				<div>
					<label class="ml-2">{{'battlinkDevice.devices.battery_voltage' | translate}}</label>
				</div>
				<ng-select
					class="mr-auto w-100"
					id="battery_voltage"
					[searchable]="false"
					[items]="batterySummaryVoltageOptions"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'battlinkDevice.devices.battery_voltage' | translate}}"
					name="battery_voltage"
					[(ngModel)]="selectedBatterySummaryVoltageFilter"
					(ngModelChange)="prepareBatterySummaryReport()"
					[clearable]="false"
				>
				</ng-select>
			</div>
			<div class="col-3">
				<div>
					<label for="battery_capacity">{{'devices.battery_capacity' | translate}}</label>
				</div>
				<ng-select
					class="mr-auto w-100"
					id="battery_capacity"
					[searchable]="false"
					[items]="batterySummaryCapacityOptions"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'devices.battery_capacity' | translate}}"
					name="battery_capacity"
					[(ngModel)]="selectedBatterySummaryCapacityFilter"
					(ngModelChange)="prepareBatterySummaryReport()"
					[clearable]="false"
				>
				</ng-select>
			</div>
		</div>
	</div>

	<sct-custom-table
		[columnsConfig]="batterySummaryUsage.column"
		[data]="batterySummaryUsage.data"
		[config]="batterySummaryUsage.config"
	>
	</sct-custom-table>
</div>

<!-- Battlink replacement report-->
<div *ngIf="allBattlinkDevices.length" class="white-box main-black mt-4 p-4 border-radius"> 
	<h4 class="mb-4">
		{{'battlinkDevice.site.battery_replacement_report' | translate}}
		<app-help-tooltip *ngIf="tooltips.battery_replacement_report" [field]="tooltips.battery_replacement_report" [field]="tooltips.battery_replacement_report"></app-help-tooltip>
	</h4>

	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="d-flex justify-content-start col-8 align-items-center">
			<div class="col-3">
				<div>
					<label for="remaining_years"> {{'battlinkDevice.devices.remaining_years' |translate}}</label>
				</div>
				<ng-select
					class="mr-auto w-100"
					[searchable]="false"
					id="battery_year"
					[items]="batteryReplacementYearsOptions"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'devices.yearFilter' | translate}}"
					name="battery_year"
					[(ngModel)]="selectedBatteryYearFilter"
					(change)="changeBatteryReplacementYearsFilter($event.value)"
					[clearable]="false"
				>
				</ng-select>
			</div>
			<div class="col-3">
				<div>
					<label for="remaining_capacity"> {{'battlinkDevice.devices.remaining_capacity' |translate}}</label>
				</div>
				<ng-select
					class="mr-auto w-100"
					id="battery_capacity_remaining"
					[searchable]="false"
					[items]="batteryCapacityOptions"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'battlinkDevice.devices.remaining_capacity' | translate}}"
					name="battery_capacity_remaining"
					[(ngModel)]="selectedBatteryCapacityFilter"
					(change)="changeBatteryReplacementCapacityFilter($event.value)"
					[clearable]="false"
				>
				</ng-select>
			</div>
		</div>
	</div>
	<sct-custom-table
		[columnsConfig]="batteryReplacementReport.column"
		[data]="batteryReplacementReport.data"
		[config]="batteryReplacementReport.config"
	>
	</sct-custom-table>
</div>

<div *ngIf="0">
	<app-usage-time-widget
		[devices]="devices"
		[site]="siteInfo"
		[tags]="tags"
		[options]="{
			hasTruckTypeFilter: true,
			hasYearFilter: true
		}"
		parentPage="site"
		tooltipKey="usage_time_site"
	></app-usage-time-widget>
</div>

<!-- ( IoTAh ) Devices Usage Data -->
<div *ngIf="IoTAhDevices.length">
	<app-usage-data
		[data]="siteDevicesAnalytics.usageData.recent.iotah"
		[columns]="siteDevicesAnalytics.usageData.recent.iotah[0] || []"
		[devices]="IoTAhDevices"
		[deviceType]="deviceFactory.types.iotah"
		[options]="{hasTruckTypeFilter: true, hasYearFilter: true, hasStackedColumn: true}"
		parentPage="site"
		[tags]="tags"
		[siteInfo]="{id: siteInfo.id, name: siteInfo.name, customer_name: siteInfo.customer_name}"
	></app-usage-data>
</div>

<!-- ( ChargLink ) Devices Usage Data [Charger Usage Data]-->
<div *ngIf="0 && chargeLinkDevices.length">
	<app-usage-data
		[data]="siteDevicesAnalytics.usageData.recent.chargLink"
		[columns]="siteDevicesAnalytics.usageData.recent.chargLink[0] || []"
		[devices]="chargeLinkDevices"
		[deviceType]="deviceFactory.types.charglink"
		[options]="{hasTruckTypeFilter: true, hasYearFilter: true, hasStackedColumn: true}"
		parentPage="site"
		[tags]="tags"
		[siteInfo]="{id: siteInfo.id, name: siteInfo.name}"
	></app-usage-data>
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="meteredDevices.length">
	<app-im-usage-report
		[siteInfo]="siteInfo"
		[devices]="meteredDevices"
	></app-im-usage-report>
</div>

<app-modal #revealPasswordConfirmModal title="{{'password_reveal.confirm_request' | translate}}" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div>
		{{'password_reveal.confirm_request_message' | translate}}
	</div>
	<div class="modal-footer">
		<button class="btn btn-default mr-2" (click)="revealPasswordConfirmModal.hide()">{{'g.cancel' | translate}}</button>
		<button class="btn btn-primary" (click)="confirmRevealPasswordRequest()">{{'g.ok' | translate}}</button>
	</div>
</app-modal>

<app-site-mailer-subscriptions #siteMailerSubscriptions [siteId]="siteId" [siteInfo]="siteInfo"></app-site-mailer-subscriptions>
